type Props = {
    imageurl: string;
    background: string;
    overlapvalue: string | number;
};

const CallOut = ({
    children,
    imageurl,
    background,
    overlapvalue,
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={`flex items-center justify-center max-w-screen-md relative w-full md:min-h-[380px]`}
        >
            <div
                className={`z-10 px-6 pt-12 pb-4 rounded-lg font-poppins w-full md:w-auto ${background} md:max-w-[380px]`}
                data-qa="call-out-content"
            >
                {children}
            </div>
            <div
                className="hidden md:block h-full"
                style={{ marginLeft: `-${overlapvalue || 15}%` }}
                data-qa="call-out-image"
            >
                <img src={imageurl} className="rounded-lg" alt="" />
            </div>
        </div>
    );
};

export default CallOut;
